import React from 'react';
import Box from '@mui/material/Box';
import { alpha, Theme, useTheme } from '@mui/material/styles';
import { monoSx } from '../dashboard/styles';

const methodColor = (theme: Theme, method: string): string => {
  switch (method) {
    case 'GET':
      return theme.palette.secondary.main;
    case 'POST':
      return theme.palette.primary.dark;
    case 'PUT':
    case 'PATCH':
      return theme.palette.warning.dark;
    case 'DELETE':
      return theme.palette.error.main;
    default:
      return theme.palette.text.secondary;
  }
};

const MethodBadge: React.FC<{ method: string }> = ({ method }) => {
  const color = methodColor(useTheme(), method);
  return (
    <Box
      component="span"
      sx={{
        ...monoSx,
        justifySelf: 'start',
        display: 'inline-flex',
        alignItems: 'center',
        height: 22,
        px: 1,
        borderRadius: 1.5,
        fontSize: 11,
        fontWeight: 600,
        color,
        bgcolor: alpha(color, 0.12),
      }}
    >
      {method}
    </Box>
  );
};

export default MethodBadge;
